module.exports = __webpack_public_path__ + "static/media/Artboard2.2b24ba01.png";